<template>
  <div class="large_page">
    <div class="admin_topbar">
      <div class="admin_topbar_mainblock">
        <h1 class="header">Настройки профиля</h1>
      </div>
    </div>
    <div class="view">

      <div class="profile_settings">
        <div class="orange_label">Настройки профиля</div>
        <div class="avatar-settings">

          <div class="avatar">
            <div class="avatarimg__wrapper">
              <img @click="handleNavAvatar" :src="$store.getters.avatar" />
              <div class="avatarimg__icons">
                <router-link to="settings"><SettingsIcon class="setting_icon"></SettingsIcon></router-link>
                <LoginIcon @click="logout"></LoginIcon>
              </div>
            </div>
            <div>
              <h6>СМЕНИТЬ ФОТО ПРОФИЛЯ</h6>
              <button class="button1" @click="$refs.avatarPicker.click()">
                Выбрать файл
              </button>
              <input
                  type="file"
                  accept="image/jpeg"
                  @change="onChange"
                  style="display: none"
                  ref="avatarPicker"
              />
              <Cropper
                  v-if="cropperVisible"
                  :imagePath="imagePath"
                  fileType="blob"
                  @save="onSave"
                  @cancel="onCancel"
              />
            </div>
          </div>

        </div>
        <div class="change-password">
          <h6>СМЕНИТЬ ПАРОЛЬ</h6>
          <p>
            <label>Введите старый пароль</label>
            <input type="text" v-model="oldPassword" />
          </p>
          <p>
            <label>Введите новый пароль</label>
            <input type="text" v-model="newPassword" />
          </p>
          <p style="margin-top: 30px;"><button class="button1" @click="changePassword">
            Сменить пароль
          </button></p>

        </div>

        <div class="delete">
          <h6>УДАЛИТЬ АККАУНТ</h6>
          <p>
            <label>
              Введите "Удалить аккаунт", чтобы можно было нажать кнопку
            </label>
            <input type="text" v-model="deleteAccountCheck" />
          </p>
          <p style="margin-top: 30px;">
            <button
                :disabled="deleteAccountCheck != 'Удалить аккаунт'"
                class="button1"
                @click="deleteAccount"
            >
              Удалить
            </button>
          </p>

        </div>
      </div>
      <div class="firm_card">
        <div class="orange_label">Карточка предприятия</div>
        <table>
          <tr>
            <td>Адрес электронной почты</td>
            <td>{{ email }}</td>
          </tr>
          <tr>
            <td>Имя</td>
            <td><input type="text" v-model="name" /></td>
          </tr>
          <tr>
            <td>Название компании</td>
            <td>
              <input type="text" v-model="companyName" />
            </td>
          </tr>
          <tr>
            <td>ИНН</td>
            <td>
              <input type="text" v-model="inn" @input="handleInputInn" />
              <div
                  v-for="contractor in dadata"
                  :key="contractor.data.hid"
                  @click="applyDataInn(contractor.data.hid)"
                  class="suggestion"
                  :class="{
                  liquidated: contractor.data.state.status == 'LIQUIDATED',
                }"
              >
                <div class="suggestion__name">
                  <span>{{ contractor.value }}</span
                  ><span
                    v-if="contractor.data.branch_type"
                    v-text="
                      contractor.data.branch_type == 'MAIN'
                        ? 'ГОЛОВНОЙ ОФИС'
                        : 'ФИЛИАЛ'
                    "
                ></span>
                </div>
                <div
                    class="suggestion__value"
                    v-if="contractor.data.management"
                >
                  <span>{{ contractor.data.management.post }}:</span>
                  <span>{{ contractor.data.management.name }}</span>
                </div>
                <div class="suggestion__value">
                  <span>ИНН: {{ contractor.data.inn }}</span
                  ><span>ОГРН: {{ contractor.data.ogrn }}</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>Телефон</td>
            <td>
              <input type="text" v-model="phone" />
            </td>
          </tr>
          <tr>
            <td>Адрес</td>
            <td>
              <input type="text" v-model="address" />
            </td>
          </tr>
          <tr>
            <td>КПП</td>
            <td><input type="text" v-model="kpp" /></td>
          </tr>
          <tr>
            <td>ОГРН</td>
            <td><input type="text" v-model="ogrn" /></td>
          </tr>
          <tr>
            <td>БИК</td>
            <td>
              <input type="text" v-model="bik" @input="handleInputBik" />
            </td>
          </tr>
          <tr>
            <td>Название банка</td>
            <td>
              <input type="text" v-model="bankName" />
            </td>
          </tr>
          <tr>
            <td>Расчётный счёт</td>
            <td><input type="text" v-model="rs" /></td>
          </tr>
          <tr>
            <td>Корреспондентский счёт</td>
            <td><input type="text" v-model="ks" /></td>
          </tr>
          <tr>
            <td>ОКПО</td>
            <td><input type="text" v-model="okpo" /></td>
          </tr>
          <tr>
            <td>ОКТМО</td>
            <td>
              <input type="text" v-model="oktmo" />
            </td>
          </tr>
          <tr>
            <td>ОКАТО</td>
            <td>
              <input type="text" v-model="okato" />
            </td>
          </tr>
          <tr>
            <td>ОКФС</td>
            <td><input type="text" v-model="okfs" /></td>
          </tr>
        </table>
        <p style="margin-top: 30px;"><button class="button1" @click="setUserData">
          Сохранить
        </button></p>
      </div>
    </div>

<!--    <div class="fixed-action-btn top-control">-->
<!--      <a-->
<!--        class="btn-floating btn-large grey"-->
<!--        title="Изменить"-->
<!--        @click="handleEdit"-->
<!--      >-->
<!--        <i class="large material-icons-outlined">{{-->
<!--          edit ? "save" : "edit"-->
<!--        }}</i>-->
<!--      </a>-->
<!--    </div>-->
  </div>
</template>

<script>
import M from "materialize-css";
import Cropper from "vue3-cropper";
import "vue3-cropper/lib/vue3-cropper.css";
import { reactive, toRefs } from "vue";
import { useStore } from "vuex";
const URL = window.URL || window.webkitURL;
export default {
  components: { Cropper },
  setup() {
    const store = useStore();
    const state = reactive({
      cropperVisible: false,
      imagePath: "",
      previewImage: null,
    });

    const onChange = (e) => {
      const file = e.target.files[0];
      state.imagePath = URL.createObjectURL(file);
      state.cropperVisible = true;

      setTimeout(() => {
        document.querySelector(".cropper").style.zIndex = 100;
        const control = document.querySelectorAll(".cropper__control")[1];
        control.querySelectorAll("span")[0].innerText = "Отмена";
        control.querySelectorAll("span")[1].innerText = "Сброс";
        control.querySelectorAll("span")[2].innerText = "Сохранить";
      }, 0);
    };

    const onSave = (res) => {
      if (typeof res === "string") {
        state.previewImage = res;
      } else {
        // state.previewImage = URL.createObjectURL(res);
        fetch("/backend/setAvatar.php", {
          method: "POST",
          headers: {
            authorization: localStorage.getItem("isLogged"),
          },
          body: res,
        });

        // store.commit("setAvatar");
        setTimeout(() => store.dispatch("getAvatar"), 1500);
      }
      state.cropperVisible = false;
    };

    const onCancel = () => {
      state.cropperVisible = false;
    };

    return {
      ...toRefs(state),
      onChange,
      onSave,
      onCancel,
    };
  },
  async mounted() {
    M.Tabs.init(document.querySelector(".tabs"), {});

    this.email = atob(localStorage.getItem("isLogged")).split(" ")[0];

    this.getUserData();
  },
  data: () => {
    return {
      dadata: [],
      edit: false,
      name: "",
      email: "",
      companyName: "",
      inn: "",
      phone: "",
      address: "",
      kpp: "",
      ogrn: "",
      bik: "",
      bankName: "",
      rs: "",
      ks: "",
      okpo: "",
      oktmo: "",
      okato: "",
      okfs: "",
      oldPassword: "",
      newPassword: "",
      deleteAccountCheck: "",
    };
  },
  methods: {
    handleEdit() {
      if (this.edit) {
        this.setUserData();
      }
      this.edit = !this.edit;
    },
    async getUserData() {
      const resp = await fetch("/backend/users.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("isLogged"),
        },
        body: JSON.stringify({
          action: "getUserData",
        }),
      });
      const data = await resp.json();
      for (let el in data) {
        if (this[el] == "") {
          this[el] = data[el];
        }
      }
    },
    async setUserData() {
      await fetch("/backend/users.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("isLogged"),
        },
        body: JSON.stringify({
          action: "setUserData",
          name: this.name,
          companyName: this.companyName,
          inn: this.inn,
          phone: this.phone,
          address: this.address,
          kpp: this.kpp,
          ogrn: this.ogrn,
          bik: this.bik,
          bankName: this.bankName,
          rs: this.rs,
          ks: this.ks,
          okpo: this.okpo,
          oktmo: this.oktmo,
          okato: this.okato,
          okfs: this.okfs,
        }),
      });
    },
    async changePassword() {
      const resp = await fetch("/backend/users.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("isLogged"),
        },
        body: JSON.stringify({
          action: "change",
          oldPassword: this.oldPassword,
          newPassword: this.newPassword,
        }),
      });
      const text = await resp.text();
      if (text == "true") {
        alert("changeSuccess");
        localStorage.removeItem("isLogged");
        this.$router.replace("/login");
      } else {
        alert("changeFail");
      }
      this.oldPassword = "";
      this.newPassword = "";
    },
    deleteAccount() {
      if (confirm("Действительно удалить ваш аккаунт?")) {
        this.setUserData(
          "delete_date",
          new Date(new Date().setDate(new Date().getDate() + 90)).toISOString()
        );
        localStorage.removeItem("isLogged");
        this.$router.replace("/login");
      }
    },

    handleInputInn(event) {
      const amount = event.target.value.length;
      const inn = event.target.value;
      if (amount == 10 || amount == 12) {
        this.handleUpdateInn(inn);
      }
    },
    handleInputBik(event) {
      const amount = event.target.value.length;
      const bik = event.target.value;
      if (amount == 9) {
        this.handleUpdateBik(bik);
      }
    },
    async handleUpdateInn(inn) {
      const url =
        "https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/party";
      const data = await this.handleUpdate(inn, url);
      this.dadata = data;
    },
    async handleUpdateBik(bik) {
      const url =
        "https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/bank";
      const data = await this.handleUpdate(bik, url);
      this.bankName = data[0].value;
      this.ks = data[0].data.correspondent_account;
    },
    async handleUpdate(query, url) {
      const token = "f2afd1063d43b79473c66ce8c57b38624c21fc19";

      const options = {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Token " + token,
        },
        body: JSON.stringify({ query: query }),
      };

      const response = await fetch(url, options);
      const data = await response.json();
      return data.suggestions;
    },
    applyDataInn(id) {
      const donor = this.dadata.find((i) => i.data.hid == id);
      this.companyName = donor.value;
      this.address = donor.data.address.unrestricted_value;
      this.kpp = donor.data.kpp;
      this.ogrn = donor.data.ogrn;
      this.okpo = donor.data.okpo;
      this.oktmo = donor.data.oktmo;
      this.dadata = [];
    },
  },
};
</script>

<style lang="stylus" scoped>
.view {
  display: flex;
  margin-top: 135px;
}
.view > div {
  flex-grow: 1;
  flex-basis: 0;
}
.profile_settings {
  margin-right: 25px;
}
.avatar {
  display: flex;
}
.avatar > div {
  flex-grow: 1;
}
.firm_card table {
  margin-bottom: 30px;
}
.firm_card table tr td:first-child {
  width: 30%;
  padding-right: 20px;
}
.avatar img {
  width: 250px;
  height: 250px;
  margin-right: 30px;
}
.white-space {
  width: calc(100% - 130px);
  height: 60px;
  position: fixed;
  background-color: #fff;
  z-index: 2;
  top: 0;
  left: 130px;
}
h6 {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 23px;
  margin-bottom: 30px;
}
#view table tr > td:nth-child(1) {
  color: #2c2738;
  opacity: 0.5;
}

.change-password {
  width: 400px;
}
.change-password .btn {
  margin: 20px 0;
}

.delete {
  width: 400px;
  margin-top: 30px;
}
.delete .btn {
  margin: 20px 0;
}

.suggestion {
  padding: 10px;

  &:hover {
    background-color: #eee;
  }

  &__name, &__value {
    display: flex;
  }

  &__value {
    font-size: 12px;
  }

  & span:first-child {
    margin-right: 20px;
  }
}

.liquidated {
  position: relative;

  &:before {
    content: 'ЛИКВИДИРОВАН';
    position: absolute;
    border: 3px solid #ff000080;
    color: #ff000090;
    font-size: 24px;
    font-weight: 900;
    text-align: center;
    left: 0;
    top: calc(50% - 21px);
    width: 100%;
  }
}
@media (max-width: 1400px) {
  .large_page .view {
    margin-top: 120px;
  }
  h6 {
    font-size: 18px;
    margin-bottom: 20px;
  }
  .avatar img {
    width: 200px;
    height: 200px;
  }
  #view table tr td {
    font-size: 13.55px;
  }
}
</style>
